import { useAuth0 } from '@auth0/auth0-react';
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import Divider from '@mui/material/Divider';
import { useRadioGroup } from '@mui/material/RadioGroup';
import { styled } from '@mui/material/styles';
import { LabelField } from 'components/LabelField';
import { MyCheckbox } from 'components/MyCheckbox';
import InfoTooltip from 'components/InfoTooltip';
import Selection from 'components/Selection/Selection';
import PastoralService from 'Lib/API/PastoralApi/index';
import React, { useEffect, useState } from 'react';
import { toastr } from 'react-redux-toastr';
import defaultUser from '../../../../assets/icons/defaultUserSetting.svg';
import { InputField } from '../../../../components/InputField';
import UserService from '../../../../Lib/API/users';
import { uploadFile } from "../../../Auth/Presigned";
import './AddUserDrawer.scss';
import VacationBox from './VacationBox';
import { fontConfig } from "theme/fontConfig";

const StyledFormControlLabel = styled((props) => (
  <FormControlLabel {...props} />
))(({ theme, checked }) => ({
  '.MuiFormControlLabel-label': checked && {
    color: theme.palette.primary.main,
  },
}));

function MyFormControlLabel(props) {
  const radioGroup = useRadioGroup();

  let checked = false;

  if (radioGroup) {
    checked = radioGroup.value === props.value;
  }

  return <StyledFormControlLabel checked={checked} {...props} />;
}

const selectControlStyles = {
  backgroundColor: "#F3F6F9",
  borderColor: "#F3F6F9",
  color: "#3F4254",
  transition:
    "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
  paddingTop: "6px",
  paddingBottom: "6px",
  cursor: "pointer",
};


const AddUserDrawer = ({
  isAddUserDrawerOpen,
  closeModal,
  handleClose,
  setOpenShabbat,
  openShabbat,
  setOpenVacation,
  openVacation,
  setTriggerUploadImg,
  triggerUploadImg,
  setProfileImage,
  profileImage,
  setUserData,
  userData,
  setRefresh,
  refresh,
  pictures,
  openMobileResetPassword,
}) => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [role, setRole] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [addUserLoading, setAddUesrLoading] = useState(false);
  const [listModules, setListModules] = useState([]);
  const [newClergy, setNewClergy] = useState(false);
  const { getAccessTokenSilently } = useAuth0();

  const [selectedModule, setSelectedModule] = useState({
    members: {},
    report: {},
    pastoral: {},
    finance: {},
    education: {},
  });
  const [usersData, setUsersData] = useState([]);
  const [eventUserLoading, setEventUserLoading] = useState(false);

  const subModuleActiveElement = {
    vacation: {
      active: true,
      component: <VacationBox 
        usersData={usersData} 
        eventUserLoading={eventUserLoading} 
        setSelectedModule={setSelectedModule}
        selectedModule={selectedModule}
      />
    }
  }


  const getUsersHandler = async () => {
    setEventUserLoading(true);
    const token = await getAccessTokenSilently();
    PastoralService.getEventUsers({ token, page: 1 })
      .then((res) => {
        if (res) {
          const formattedUsers = res?.users.map((item) => ({ 
            label: `${item?.type} ${item?.fullName ? "- " + item?.fullName : ""}`,
            value: item?.id 
          }));
          setUsersData(formattedUsers);
        }
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setEventUserLoading(false);
      });
  };
  useEffect(() => {
    getAuthorizedModules();
    getUsersHandler();
  }, []);

  const moduleFiltered = [];

  for (const key in selectedModule) {
    if (selectedModule[key] !== '') {
      const hasSubModule = Object.keys(selectedModule[key]?.subModule || {})?.length > 0;
      moduleFiltered.push({
        moduleName: key,
        active: selectedModule[key]?.active === "true" ? true : false,
        ...(selectedModule[key]?.description?.value ? 
          {
            description: selectedModule[key]?.description?.value?.toString(),
          } : {}
        ),
        ...(hasSubModule ? {
          subModule: Object.keys(selectedModule[key]?.subModule)?.map((subKey) => ({
            subModuleName: subKey,
            active: selectedModule[key]?.subModule?.[subKey]?.active === "true" ? true : false,
            ...(selectedModule[key]?.subModule?.[subKey]?.description?.value ? {
                description: selectedModule[key]?.subModule?.[subKey]?.description?.value?.toString(),
              } : {}
            ),
          }))
        } : {})
      });
    }
  }
  const listModulesValidate = listModules.map((item) => ({
    moduleName: item?.moduleName,
    available: item?.available,
  }));


  // user validation
  const validateSubmit = () => {
    if (!firstName || !lastName || !role || !email) {
      return toastr.info('Please fill all user fields');
    }

    const listModulesValidate = listModules.map((item) => ({
      moduleName: item?.moduleName,
      available: item?.available,
    }));
    for (let { moduleName, available } of listModulesValidate) {
      if (available && !selectedModule[moduleName]) {
        return toastr.info('Please fill the user permissions');
      }
    }
    addUserApi();
  };

  const addUserApi = async (e) => {
    setAddUesrLoading(true);
    const token = await getAccessTokenSilently();
    const newUrl = (await pictures?.length)
      ? await uploadFile(pictures[0], pictures[0], token)
      : "";
      const payload = {
        email,
        first_name: firstName,
        last_name: lastName,
        role,
        profile_img: newUrl.fileName ? newUrl.fileName : undefined,
        authorizedModules: moduleFiltered,
      }
    await UserService.addUser(token, payload)
      .then((res) => {
        const clergyType = selectedModule?.pastoral?.description;
        if(newClergy) {
          return createNewClergyHandler({
            ...payload,
            easy_contact_id: res?.permissions?.linked_contact,
            auth0_id: res?.auth0_id,
          });
        } else if (clergyType?.value) {
          return updateClergyHandler({
            id: clergyType?.value,
            contactId: res?.permissions?.linked_contact,
          });
        }
        handleAfterCreate();
      })
      .catch((err) => {
        console.log('err: ', err);
        setAddUesrLoading(false);
        return toastr.error(
          err.data.validation
            ? err.data.validation[0].message
            : err.data.message
        );
      });
  };

  const createNewClergyHandler = async (data) => {
    const token = await getAccessTokenSilently();
    const payload = {
      fname: data?.first_name,
      lname: data?.last_name,
      email: data?.email,
      role: data?.role,
      easy_contact_id: data?.easy_contact_id,
      auth0_id: data?.auth0_id,
    }
    await PastoralService.createNewClergy({token, data:payload})
      .then((response) => {
        handleAfterCreate(true, payload?.easy_contact_id);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setAddUesrLoading(false);
      });
  }
  const updateClergyHandler = async (data) => {
    const token = await getAccessTokenSilently();
    const payload = {
      id: data?.id?.toString(),
      contactId: data?.contactId,
    }
    await PastoralService.updateClergy({token, data:payload})
      .then((response) => {
        handleAfterCreate();
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setAddUesrLoading(false);
      });
  }

  const handleAfterCreate = (showResetPassword, contactId) => {
    setRefresh(!refresh);
    setAddUesrLoading(false);
    if(showResetPassword) {
      openMobileResetPassword("add", contactId);
    } else {
      handleClose();
      setProfileImage('');
    }
    return toastr.success('User Created Successfully');
  }

  const getAuthorizedModules = async () => {
    setLoading(true);
    const token = await getAccessTokenSilently();
    await UserService.authorizedModules(token).then((res) => {
      let formattedModulesList = {};
      const formattedModules = res.result.map((item) => {
        if(item?.available) {
          formattedModulesList[item?.moduleName] = {
            active: "false",
          };
        }
      });
      setSelectedModule(formattedModulesList);
      setListModules(res.result);
      setLoading(false);
    });
  };



  return (
    <Box
      width="570px"
      textAlign="center"
      role="presentation"
      sx={{ padding: '28px 45px', fontFamily: fontConfig.SettingsAddUserDrawerTextFont.family }}
    >
      <div
        className="text-left"
        style={{ fontSize: '16px', cursor: 'pointer' }}
        onClick={() => {
          closeModal();
          setProfileImage('');
        }}
      >
        x
      </div>

      <div className="add__user__header d-flex justify-content-between align-items-center mt-3">
        <p className="create_new_user_text">Create New User </p>
        <div className="user__header__action">
          <button
            className="cancel_user_btn"
            onClick={() => closeModal()}
          >
            <span className="user_btn_cancel btn">Cancel</span>
          </button>
          <button
            className="save_user_btn btn btn-primary"
            onClick={() => validateSubmit()}
            disabled={addUserLoading}
          >
            <span className="user_btn_text">Save</span>
            {addUserLoading && (
              <span className="ml-3 spinner spinner-white"></span>
            )}
          </button>
        </div>
      </div>
      <div
        className="user__photo mt-5"
        onClick={() => setTriggerUploadImg(true)}
      >
        <img
          src={!triggerUploadImg && profileImage ? profileImage : defaultUser}
          alt="user"
          style={{
            width: '92px',
            height: '92px',
            borderRadius: '50%',
            cursor: 'pointer',
          }}
        />
        <p
          style={{
            color: '#2555EF',
            fontSize: '16px',
            fontWeight: '600',
            marginTop: '10px',
            cursor: 'pointer',
            fontFamily: fontConfig.SettingsAddUserDrawerTextFont.family,
          }}
        >
          Update photo
        </p>
      </div>
      <div className="first__field d-flex align-items-center justify-content-between">
        <InputField
          mandatory
          type="text"
          {...{
            title: 'First Name',
            placeholder: 'first name',
          }}
          value={firstName}
          handleChange={(e) => {
            setFirstName(e.target.value);
          }}
        />
        <InputField
          mandatory
          type="text"
          title="Last Name"
          placeholder="last name"
          value={lastName}
          handleChange={(e) => setLastName(e.target.value)}
        />
      </div>
      <div className="second__field">
        <InputField
          mandatory
          type="text"
          title="Role"
          placeholder="role"
          value={role}
          handleChange={(e) => setRole(e.target.value)}
        />
      </div>
      <div className="second__field">
        <InputField
          mandatory
          type="text"
          title="Email"
          placeholder="email"
          value={email}
          handleChange={(e) => setEmail(e.target.value)}
        />
      </div>
      <Divider
        sx={{ marginTop: '35px', marginBottom: '67px', color: '#002E5C' }}
      />
      <Typography
        variant="subtitle1"
        className="mt-3 mb-3 ml-2 d-flex align-items-center"
        sx={{ color: '#9FA0A2', gap: '6px' }}
        textAlign="left"
      >
        PERMISSIONS
        <InfoTooltip text="For each module, Admin gives this staff user full access and Disable gives none. There is no partial or view-only access." placement="bottom" />
      </Typography>
      <div className="input_radio_field">
        {listModules.length === 0 ? (
          loading ? (
            <p>loading...</p>
          ) : (
            <p>No Modules Available</p>
          )
        ) : (
          listModules.map(({ _id, moduleName, subModule, available }, ndx) => {
            const isLast = listModules.length - 1 === ndx;
            return (
              <div key={_id}>
                <div className="first_field">
                  <div
                    className={`role__field ${!available ? 'disable__module' : ''
                      }`}
                  >
                    {moduleName}
                  </div>
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby="Members"
                      name={moduleName}
                      value={selectedModule[moduleName]?.active}
                      onChange={(e) =>{
                        setSelectedModule((prev) => ({
                          ...prev,
                          [moduleName]: {
                            ...prev[moduleName],
                            active: e.target.value,
                          },
                        }))
                        if(moduleName === "pastoral") {
                          setNewClergy(false);
                        }
                      }}
                    >
                      <MyFormControlLabel
                        value="true"
                        control={<Radio size="small" disabled={!available} />}
                        label="Admin"
                      />
                      <MyFormControlLabel
                        value="false"
                        control={<Radio size="small" disabled={!available} />}
                        label="Disable"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
                {(subModule?.length > 0 && selectedModule[moduleName]?.active === 'true') && (
                  <div className="shabbat">
                    <div
                      className="form-group mt-5"
                      style={{
                        textAlign: 'left',
                      }}
                    >
                      <div className='d-flex justify-content-between align-items-center'>
                        <LabelField
                          title={"Clergy type"}
                          style={{
                            fontSize: "12px",
                          }}
                          mandatory={false}
                        />
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <MyCheckbox
                            title="create new"
                            handlechange={(e) => {
                              const {checked} = e.target;
                              setNewClergy(checked);
                              setSelectedModule((prev) => ({
                                ...prev,
                                [moduleName]: {
                                  ...prev[moduleName],
                                  description: "",
                                },
                              }));
                            }}
                            checked={newClergy}
                            style={{

                            }}
                          />
                          <InfoTooltip text="Switches from picking an existing clergy record to typing a brand-new role name." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                        </div>
                      </div>
                      {newClergy ? (
                         <InputField
                          type="text"
                          value={role}
                          disabled={true}
                          title="none"
                          placeholder="Please enter a role"
                        />
                      ) :
                      (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Selection
                          name="clergyType"
                          mandatory={false}
                          placeholder="Select a clergy"
                          options={usersData}
                          isLoading={eventUserLoading}
                          style={"secondary"}
                          onChange={(value) => {
                            setSelectedModule((prev) => ({
                              ...prev,
                              [moduleName]: {
                                ...prev[moduleName],
                                description: value,
                              },
                            }));
                          }}
                          value={selectedModule[moduleName]?.description}
                          isClearable={true}
                          isDisabled={newClergy}
                        />
                        <InfoTooltip text="Assigns this user to an existing clergy or officiant record used by the Pastoral module." style={{ marginLeft: '6px' }} />
                        </div>
                      )}
                    </div>
                    {subModule?.map(({ _id, subModuleName, active }, subIndex) => (
                      <div className='mt-5' key={_id}>
                        <div className="first_field_shabbat">
                          <div className="shabbat__text">{subModuleName}</div>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                          <FormControl>
                            <RadioGroup
                              row
                              aria-labelledby={subModuleName}
                              name={subModuleName}
                              value={selectedModule[moduleName]?.subModule?.[subModuleName]?.active || "no"}
                              onChange={(e) => {
                                setSelectedModule((prev) => ({
                                  ...prev,
                                  [moduleName]: {
                                    ...prev[moduleName],
                                    subModule: {
                                      ...prev[moduleName]?.subModule,
                                      [subModuleName]: {
                                        ...prev[moduleName]?.subModule?.[subModuleName],
                                        active: e.target.value,
                                      },
                                    }
                                  },
                                }));
                              }}
                              defaultValue={selectedModule[moduleName]?.subModule?.[subModuleName]?.active || "no"}
                            >
                              <MyFormControlLabel
                                value="yes"
                                control={<Radio size="small" />}
                                label="Yes"
                              />
                              <MyFormControlLabel
                                value="no"
                                control={<Radio size="small" />}
                                label="No"
                              />
                            </RadioGroup>
                          </FormControl>
                          <InfoTooltip text="Independently grants access to this Pastoral submodule feature." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                          </div>
                        </div>
                        {subIndex !== subModule.length - 1 && (
                          <Divider
                            sx={{
                              color: '#3F4255',
                              marginTop: '12px',
                              marginBottom: '12px',
                            }}
                          />
                        )}
                        {(selectedModule[moduleName]?.subModule?.[subModuleName]?.active === 'yes' && subModuleActiveElement?.[subModuleName]?.active) ? subModuleActiveElement?.[subModuleName]?.component : null}
                      </div>
                    ))}

                  </div>
                )}
                {!isLast && (
                  <Divider
                    sx={{
                      color: '#3F4255',
                      marginTop: '12px',
                      marginBottom: '12px',
                    }}
                  />
                )}
              </div>
            );
          })
        )}

      </div>
    </Box>
  );
};

export default AddUserDrawer;
